import React, { useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import { ALTTAGS } from "../../constants/content/en";
import theme from "../../constants/themes";
import {
  CAROUSEL_TRANSITION_DELAY,
  CAROUSEL_TRANSITION_TIMING,
  FORGOT_PASSWORD_MODULE,
  SIGN_IN_MODULE,
  SIGN_UP_MODULE,
  SUCCESS_AUTH
} from "../../constants/variables";
import { DEVICE_TYPE_MOBILE } from "../../constants/viewports";
import { screenContext } from "../../context/ScreenContext";
import { setOpenSignIn } from "../../store/slices/login";
import ForgotPasswordModule from "./ForgotPassword";
import SignInModule from "./SignIn";
import SignUpModule from "./SignUp";
import { ModalV2 } from "components/V2/atoms/ModalV2/ModalV2";

function UserAuthentication({ blok, resourceData }) {
  const [module, setModule] = useState(SIGN_IN_MODULE);
  const [successModule, setSuccessModule] = useState("");
  const { currentDevice } = useContext(screenContext);
  const login = useSelector((state: any) => state.nonPersistedReducers.login);  
  const { openSignIn } = login;
  
  const dispatch = useDispatch();
  // ? accepts a boolean and updates the state with the boolean
  // ? If boolean is true, the form is shown else it's hidden
  const handleModuleOpen = (value: boolean | ((prevState: boolean) => boolean)) => {
    dispatch(setOpenSignIn({openSignIn: value}))
    setModule(SIGN_IN_MODULE);
  };

  const handleModule = (updatedModule) => {
    setModule(updatedModule);
  };

  const Container = {
    height: currentDevice == DEVICE_TYPE_MOBILE ? "100vh" : "650px"
  };

  const indicatorStyles = {
    width: 33,
    height: 2,
    backgroundColor: theme.lightMode.primaryWhite,
    margin: `${blok.indicatorMargin ? blok.indicatorMargin : "0 4px"}`,
    borderRadius: "5px",
    opacity: "0.5",
    display: `${blok.indicatorVisibility === "none" ? "none" : "inline-block"}`
  };

  const handleSuccess = (originModule: string) => {
    setSuccessModule(originModule);
    setModule(SUCCESS_AUTH);
  };

  const baseChildren = (
    <div className="w-full h-full">
      {blok?.loginModalBannerImages?.map((ele, ind) => (
        <div className="w-full h-full" key={ind}>
          {ele?.desktopImage?.filename ? (
            <img
              className="w-full h-full z-0"
              style={Container}
              src={ele?.desktopImage?.filename}
              alt={ele?.desktopImage?.alt || ALTTAGS?.image}
            />
          ) : null}

          <div className=" w-full absolute top-60 bottom-40 text-center flex-col mt-10 z-5">
            <h2 className="w-2/3 text-white font-medium text-5xl text-center m-auto">{ele.label}</h2>
          </div>
        </div>
      ))}
    </div>
  );

  // ? returns user authentication module
  return (
    <div>
      {
        <ModalV2
          isOpen={openSignIn}
          size="XXL"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          scrollable={true}
          showBorderRadius={true}
          hideTitleCloseIcon={true}
          maxHeight = { currentDevice == DEVICE_TYPE_MOBILE ? "100%" : "calc(100% - 64px)"}
        >
          <div className="flex h-[95vh] sm:h-full">
            <div className="w-2/3 h-full hidden lg:block  login-crousal-mobile ">
              <div className="h-full">
                <Carousel
                  showThumbs={false}
                  showStatus={false}
                  showArrows={false}
                  axis="horizontal"
                  autoPlay
                  infiniteLoop
                  transitionTime={CAROUSEL_TRANSITION_TIMING}
                  interval={CAROUSEL_TRANSITION_DELAY}
                  renderIndicator={(onClickHandler, isSelected, index, label) => {
                    if (isSelected) {
                      return (
                        <li
                          className="relative bottom-20"
                          style={{
                            ...indicatorStyles,
                            opacity: "1"
                          }}
                          aria-label={`Selected: ${label} ${index + 1}`}
                          title={`Selected: ${label} ${index + 1}`}
                        />
                      );
                    }
                    return (
                      <li
                        className="relative bottom-20"
                        style={indicatorStyles}
                        onClick={onClickHandler}
                        onKeyDown={onClickHandler}
                        value={index}
                        key={index}
                        role="button"
                        tabIndex={0}
                        title={`${label} ${index + 1}`}
                        aria-label={`${label} ${index + 1}`}
                      />
                    );
                  }}
                >
                  {baseChildren.props.children}
                </Carousel>
              </div>
            </div>

            <div className="auth_side_bar p-4 sm:px-0 h-full w-full lg:w-2/6">
              {module === SIGN_IN_MODULE ? (
                <SignInModule
                  handleOpen={handleModuleOpen}
                  handleModule={handleModule}
                  resourceData={resourceData}
                  handleSuccess={handleSuccess}
                />
              ) : module === FORGOT_PASSWORD_MODULE ? (
                <ForgotPasswordModule
                  handleOpen={handleModuleOpen}
                  handleModule={handleModule}
                  resourceData={resourceData}
                  handleSuccess={handleSuccess}
                />
              ) : module === SIGN_UP_MODULE ? (
                <SignUpModule
                  handleOpen={handleModuleOpen}
                  handleModule={handleModule}
                  resourceData={resourceData}
                  handleSuccess={handleSuccess}
                />
              ) : null}
            </div>
          </div>
        </ModalV2>
      }
    </div>
  );
}

export default UserAuthentication;
